import DataTranslationsProps, {
    DataTranslationStrings,
} from "../types/DataTranslations";

declare let dataTranslations: DataTranslationsProps;

class Translation {
    currentLang: string;
    strings: DataTranslationStrings;

    constructor() {
        this.currentLang = dataTranslations.currentLang;
        this.strings = dataTranslations.strings;
    }

    getText(group: string, key: string) {
        return this.strings[group][key];
    }
}

export default new Translation();
